import React from "react";
import FloatingDropdown from "../../../components/FloatingDropdown";

function CreateAppointmentsButtons({
  handleSetOpenFuel,
  handleSetOpenMaintenance,
  props,
}) {
  return (
    <div>
      <FloatingDropdown>
        <li>
          <a
            data-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="collapseFuel"
            onClick={handleSetOpenFuel}
          >
            Novo Abastecimento
          </a>
        </li>
        <li>
          <a
            data-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="collapseMaintenance"
            onClick={handleSetOpenMaintenance}
          >
            Nova manutenção
          </a>
        </li>
      </FloatingDropdown>
    </div>
  );
}

export default CreateAppointmentsButtons;
